import React from 'react'
import CheckIcon from 'material-ui/svg-icons/navigation/check'

import * as Constants from '../../helpers/Constants'

const TableItem = ({ children, icon }) => {
  const { containerStyle, iconStyle } = styles
  return (
    <div style={containerStyle}>
      {icon ? icon : <CheckIcon style={iconStyle} />}
      {children}
    </div>
  )
}

const styles = {
  containerStyle: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginTop: 30
  },
  iconStyle: {
    fill: Constants.WHITE_LABEL.colors.primary,
    margin: 0,
    height: 30,
    width: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}

export { TableItem }



// WEBPACK FOOTER //
// ./src/components/common/TableItem.js